import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
  DatePicker,
} from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'

export default function ProjectActiveSeparateIssuesForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  clearValue,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)

  const [fromBudgetYearOptions, setFromBudgetYearOptions] = useState(schema.fromBudgetYear.options)
  const [toBudgetYearOptions, setToBudgetYearOptions] = useState(schema.toBudgetYear.options)
  const [startDates, setStartDates] = useState(null)
  const [endDates, setEndDates] = useState(null)

  useEffect(() => {
    if (!clearValue) {
      setStartDates(null)
      setEndDates(null)

      const indexOptionFromBudgetYear = schema.fromBudgetYear.options.length - 1
      const indexOptionToBudgetYear = schema.fromBudgetYear.options.length - 1

      setValue(
        schema.fromBudgetYear.name,
        schema.fromBudgetYear.options[indexOptionFromBudgetYear].value
      )
      setValue(schema.toBudgetYear.name, schema.toBudgetYear.options[indexOptionToBudgetYear].value)
      setValue(schema.processAreaCheckbox.name, 1)
      setValue(schema.healthAreaCheckbox.name, 1)
      setValue(schema.targetCheckbox.name, 1)
      setValue(schema.addressCheckbox.name, 1)
    }
  }, [clearValue])

  const handleChangeBudgetYear = (name, value) => {
    if (value) {
      let bgy = getValues(name)
      if (!bgy) {
        setValue(name, value)
        clearErrors(name)
      } else if (name == schema.fromBudgetYear.name && bgy > value) {
        setValue(name, value)
      } else if (name == schema.toBudgetYear.name && bgy < value) {
        setValue(name, value)
      }

      if (name == schema.fromBudgetYear.name) {
        setFromBudgetYearOptions(schema.fromBudgetYear.options.filter((e) => e.value <= value))
      }

      if (name == schema.toBudgetYear.name) {
        setToBudgetYearOptions(schema.toBudgetYear.options.filter((e) => e.value >= value))
      }
    } else {
      if (name == schema.fromBudgetYear.name) {
        setFromBudgetYearOptions(schema.fromBudgetYear.options)
      }

      if (name == schema.toBudgetYear.name) {
        setToBudgetYearOptions(schema.toBudgetYear.options)
      }
    }
  }

  const Styles = {
    labelStyle: {
      marginTop: '5px',
      padding: '8px',
      textAlign: 'right',
    },
    inputStyle: {
      marginTop: '5px',
      padding: '8px',
    },
  }

  const generateCheckbox = (options) => {
    return options.map((item, index) => {
      return (
        <>
          <Checkbox value={item.value} key={index}>
            {item.label}
          </Checkbox>
        </>
      )
    })
  }

  return (
    <>
      <Form>
        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {requiredFiled(schema.fromBudgetYear.validators, schema.fromBudgetYear.label)}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors[schema.fromBudgetYear.name]} />
            <Controller
              name={schema.fromBudgetYear.name}
              control={control}
              defaultValue={
                fromBudgetYearOptions
                  ? Math.max(...fromBudgetYearOptions.map((item) => item.value))
                  : schema.fromBudgetYear.value
              }
              rules={isValidators(schema.fromBudgetYear.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={fromBudgetYearOptions}
                    // disabled={disabledValue.fromBudgetYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.fromBudgetYear.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      handleChangeBudgetYear(schema.toBudgetYear.name, value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {requiredFiled(schema.toBudgetYear.validators, schema.toBudgetYear.label)}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors[schema.toBudgetYear.name]} />
            <Controller
              name={schema.toBudgetYear.name}
              control={control}
              defaultValue={
                toBudgetYearOptions
                  ? Math.max(...toBudgetYearOptions.map((item) => item.value))
                  : schema.toBudgetYear.value
              }
              rules={isValidators(schema.toBudgetYear.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={toBudgetYearOptions}
                    // disabled={disabledValue.toBudgetYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.toBudgetYear.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      handleChangeBudgetYear(schema.fromBudgetYear.name, value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          {schema?.projectStartDate && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectStartDate.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectStartDate.name]} />
                <Controller
                  key={schema.projectStartDate.name}
                  name={schema.projectStartDate.name}
                  control={control}
                  defaultValue={
                    schema.projectStartDate.value
                      ? moment(schema.projectStartDate.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={startDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setStartDates(value)
                        }}
                        disabledDate={(date) =>
                          endDates && moment(endDates).isBefore(date, new Date())
                        }
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.projectEndDate && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectEndDate.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectEndDate.name]} />
                <Controller
                  key={schema.projectEndDate.name}
                  name={schema.projectEndDate.name}
                  control={control}
                  defaultValue={
                    schema.projectEndDate.value
                      ? moment(schema.projectEndDate.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.preApprovedProjectEndDate.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={endDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setEndDates(value)
                        }}
                        disabledDate={(date) =>
                          startDates && moment(startDates).isAfter(date, new Date())
                        }
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.staffName.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors[schema.staffName.name]} />
            {/* <Input
              placeholder={schema.staffName.hint}
              defaultValue={schema.staffName.value}
              name={schema.staffName.name}
              // inputRef={register(isValidators(schema.startBudget.validators))}
              inputRef={register()}
            /> */}
            <Controller
              name={schema.staffName.name}
              control={control}
              defaultValue={schema.staffName.value}
              rules={isValidators(schema.staffName.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.staffName.options}
                    // disabled={disabledValue.toBudgetYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.staffName.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      // handleChangeBudgetYear(schema.fromBudgetYear.name, value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.projectDepartment.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors[schema.projectDepartment.name]} />
            <Controller
              name={schema.projectDepartment.name}
              control={control}
              defaultValue={schema.projectDepartment.value}
              // rules={isValidators(schema.projectDepartment.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.projectDepartment.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.projectDepartment.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.projectStatusOption.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors[schema.projectStatusOption.name]} />
            <Controller
              name={schema.projectStatusOption.name}
              control={control}
              defaultValue={schema.projectStatusOption.value}
              // rules={isValidators(schema.projectStatusOption.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.projectStatusOption.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder={`เลือก${schema.projectStatusOption.label}`}
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.processAreaCheckbox.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors.processAreaCheckbox} />
            <Controller
              name={schema.processAreaCheckbox.name}
              control={control}
              defaultValue={schema.processAreaCheckbox.value || 1}
              // rule={register(isValidators(schema.processAreaCheckbox.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    name={schema.processAreaCheckbox.name}
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.processAreaCheckbox?.options &&
                      schema.processAreaCheckbox.options.map((item) => (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.healthAreaCheckbox.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors.healthAreaCheckbox} />
            <Controller
              name={schema.healthAreaCheckbox.name}
              control={control}
              defaultValue={schema.healthAreaCheckbox.value || 1}
              // rule={register(isValidators(schema.healthAreaCheckbox.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    name={schema.healthAreaCheckbox.name}
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.healthAreaCheckbox?.options &&
                      schema.healthAreaCheckbox.options.map((item) => (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.targetCheckbox.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors.targetCheckbox} />
            <Controller
              name={schema.targetCheckbox.name}
              control={control}
              defaultValue={schema.targetCheckbox.value || 1}
              // rule={register(isValidators(schema.targetCheckbox.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    name={schema.targetCheckbox.name}
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.targetCheckbox?.options &&
                      schema.targetCheckbox.options.map((item) => (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={8} xs={8} style={Styles.labelStyle}>
            {schema.addressCheckbox.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={Styles.inputStyle}>
            <ErrorMessage error={errors.addressCheckbox} />
            <Controller
              name={schema.addressCheckbox.name}
              control={control}
              defaultValue={schema.addressCheckbox.value || 1}
              // rule={register(isValidators(schema.addressCheckbox.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    name={schema.addressCheckbox.name}
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.addressCheckbox?.options &&
                      schema.addressCheckbox.options.map((item) => (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
        </Row>
      </Form>
    </>
  )
}
